/**
 * Directive: detailHeader
 */
angular.module('acme.common.directive.detailHeader', [])
.directive('detailHeader', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/detailHeader/detailHeader.tpl.html',
      scope: {
        image: '@',
        name: '@',
        extras: '@',
        home: '@',
        links: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.detailHeader = {

          getHomeLink: function() {
            return $scope.home || '#';
          }

        };

      }]

    };

}]);